// extracted by mini-css-extract-plugin
module.exports = {"skiplink":"SkipLink-styles-module--skiplink--2HGNv"};